import '../styles/cinema-tabs.scss'
import { CmsLinkComponent } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import { cmsDataService } from '@/common/services/cms.data.service'

export const CinemaTabs: FC = () => {
    const cinemaTabs = cmsDataService.get().header?.cinemaTabs

    const alternativeTabLink = cinemaTabs?.alternativeTabLink || {
        name: 'Home Cinema',
        target: '_self',
        url: 'https://homecinema.curzon.com/',
    }

    return (
        <span className="cinema-tabs">
            <div className="cinema-tabs__active">{cinemaTabs?.activeTabLabel}</div>
            <CmsLinkComponent className="cinema-tabs__alternative" link={alternativeTabLink} />
        </span>
    )
}
